import { Box, Divider, Stack, useMediaQuery, useTheme } from '@mui/material';

import { CREATE_SERVICE_PREVIEW_WIDTH, Z_INDEX_MOBILE_NAVBAR } from 'constants/ui/style';

type Props = {
  previewElement: React.ReactNode;
  continueElement: React.ReactNode;
  cancelElement?: React.ReactNode;
};

const ContinueAndPreviewContainer = (props: Props) => {
  const { previewElement, continueElement, cancelElement } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          borderTop: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'space-around',
          padding: '0.75rem',
          zIndex: Z_INDEX_MOBILE_NAVBAR,
          backgroundColor: 'background.paper',
        }}
      >
        <Stack direction="row" justifyContent={'space-between'} sx={{ width: '100%' }} spacing={0.5}>
          {cancelElement && <Box sx={{ flex: 1 }}>{cancelElement}</Box>}
          <Box sx={{ flex: 1 }}>{continueElement}</Box>
        </Stack>
      </Box>
    );
  }

  return (
    <Stack
      sx={theme => ({
        width: CREATE_SERVICE_PREVIEW_WIDTH,
        borderLeft: `1px solid ${theme.palette.divider}`,
        height: `100%`,
        padding: `1rem 0 1rem 1rem`,
        overflow: 'hidden',
      })}
      spacing={2}
      justifyContent="space-between"
      direction="column"
    >
      {/* Content */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          position: 'relative',
        }}
      >
        {previewElement}
      </Box>
      {/* Bottom Action*/}
      <Stack
        gap={3}
        sx={{
          minHeight: '3rem',
          flexShrink: 0,
        }}
      >
        <Divider orientation="horizontal" flexItem />
        <Box>{continueElement}</Box>
      </Stack>
    </Stack>
  );
};

export default ContinueAndPreviewContainer;
